import { render, staticRenderFns } from "./Debitor.vue?vue&type=template&id=5979782d&"
import script from "./Debitor.vue?vue&type=script&lang=js&"
export * from "./Debitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports